export const generateBlogUrl = (slug: string) => `/blog/${slug}/`
